import { render, staticRenderFns } from "./MobileEventPopover.vue?vue&type=template&id=23997858"
import script from "./MobileEventPopover.vue?vue&type=script&lang=js"
export * from "./MobileEventPopover.vue?vue&type=script&lang=js"
import style0 from "./MobileEventPopover.vue?vue&type=style&index=0&id=23997858&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports